exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header{height:55px}.content{height:calc(100vh - 55px)}", ""]);

// exports
